/*
 * @Author: gujianghua
 * @Date:   2018-07-21 18:00:58
 * @Last Modified by:   gujianghua
 * @Last Modified time: 2018-08-09 11:56:21
 */
import { service } from '@/utils/request'

export default {
  //获取所有角色列表(不包含禁用)
  getAllUsingRoleList: () => {
    return service({
      url: '/cloud/uac/v1/admin/role/allUsingRoleList',
      method: 'get',
    })
  },
  //分页获取账号列表
  getAccountList: (path, data) => {
    return service({
      url: '/cloud/uac/v1/admin/account/list' + path,
      method: 'post',
      data: data
    })
  },
  //删除账号
  deleteAccount(path) {
    return service({
      url: '/cloud/uac/v1/admin/account/del' + path,
      method: 'post',
    })
  },
  //添加账号
  addAccount(data) {
    return service({
      url: '/cloud/uac/v1/admin/account/add',
      method: 'post',
      data: data
    })
  },
  //获取账号详情
  getCountDetail(path) {
    return service({
      url: '/cloud/uac/v1/admin/account/detail' + path,
      method: 'get',
    })
  },
  //更新账号
  editAccount(path,data) {
    return service({
      url: '/cloud/uac/v1/admin/account/update' + path,
      method: 'post',
      data: data
    })
  },
  //更换账号状态（禁止和启用）
  toggleAccountState(path) {
    return service({
      url: '/cloud/uac/v1/admin/account/toggle' + path,
      method: 'post',
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/systemManage/accountManage.js